<template>
  <div class="form-group" v-if="dataKey">
    <label>{{ label }}</label>
    <input type="file" class="d-none"
           ref="input"
           @change="onImageChange"
           accept="image/jpeg,image/png,image/gif,image/webp"
           :data-key="dataKey"/>
    <button type="button" class="btn btn-primary w-100 mt-2"
            @click="$refs.input.click()">
      {{ buttonTitle }}
    </button>

    <img v-if="previewImage" :src="previewImage"/>
    <img v-else-if="files && files[dataKey]"
         :src="ServerUrl(files[dataKey].url)"/>
    <img v-else-if="defaultImage && defaultImage.url"
         :src="ServerUrl(defaultImage.url)"/>

  </div>

</template>

<script>
import {ServerUrl} from "@/tools/functions";

export default {
  name: "OptionsImageUploader",
  emits: ['changed', 'input'],
  props: {
    dataKey: {default: undefined},
    label: {default: 'فایل'},
    buttonTitle: {default: 'انتخاب فایل'},
    defaultImage: {default: undefined},
    files: {default: () => ({})},
    value: {default: undefined}
  },
  data: () => ({
    previewImage: false
  }),
  methods: {
    ServerUrl,
    onImageChange() {
      this.$emit('input', this.$refs.input.files.length > 0 ? this.$refs.input.files[0] : undefined);
      this.$emit('changed', this.$refs.input.files);
      if (this.$refs.input.files.length > 0) {
        const fd = new FileReader();
        fd.onload = () => {
          this.previewImage = fd.result;
        };
        fd.readAsDataURL(this.$refs.input.files[0]);
      }
    },
  },
}
</script>

<style scoped>

</style>